'use client';

import { useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';

const services = [
  {
    icon: 'ScissorsIcon',
    title: 'Hair Cuts & Styling',
    desc: 'Precision cuts tailored to your face shape, lifestyle, and personality. From classic bobs to dramatic transformations.',
    tag: 'Most Popular',
    tagColor: 'bg-gold text-white',
    price: 'From $65',
    size: 'large',
  },
  {
    icon: 'SparklesIcon',
    title: 'Color & Balayage',
    desc: 'Dimensional color, balayage, highlights, and ombré crafted by our color specialists.',
    tag: null,
    price: 'From $120',
    size: 'small',
  },
  {
    icon: 'HeartIcon',
    title: 'Bridal Packages',
    desc: 'Complete bridal beauty from hair to makeup. Trials included. Your most perfect day.',
    tag: 'Signature',
    tagColor: 'bg-rose text-white',
    price: 'From $380',
    size: 'small',
  },
  {
    icon: 'FaceSmileIcon',
    title: 'Facials & Skin Care',
    desc: 'Hydrating, anti-aging, and brightening facials using premium organic skincare lines.',
    tag: null,
    price: 'From $90',
    size: 'medium',
  },
  {
    icon: 'HandRaisedIcon',
    title: 'Manicure & Pedicure',
    desc: 'Classic, gel, and nail art services. Shellac, acrylics, and luxury nail couture.',
    tag: null,
    price: 'From $45',
    size: 'medium',
  },
  {
    icon: 'SunIcon',
    title: 'Waxing & Threading',
    desc: 'Precise hair removal for face and body using premium wax and threading techniques.',
    tag: null,
    price: 'From $25',
    size: 'small',
  },
  {
    icon: 'CloudIcon',
    title: 'Head Spa & Massage',
    desc: 'Deeply relaxing scalp treatments and head massages for ultimate stress relief and hair health.',
    tag: 'New',
    tagColor: 'bg-espresso text-white',
    price: 'From $75',
    size: 'small',
  },
  {
    icon: 'StarIcon',
    title: 'Lash & Brow',
    desc: 'Extensions, lifts, tints, and microblading for perfectly framed eyes every day.',
    tag: null,
    price: 'From $55',
    size: 'medium',
  },
];

export default function ServicesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll<HTMLElement>('.service-reveal');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 80);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section data-component-id="src/app/homepage/components/ServicesSection.tsx:103:4" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="103" data-component-end-line="240" data-component-file="ServicesSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22services%22%2C%22className%22%3A%22py-28%20px-6%22%7D" id="services" className="py-28 px-6" style={{ background: 'var(--cream)' }}>
      <div data-component-id="src/app/homepage/components/ServicesSection.tsx:104:6" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="104" data-component-end-line="239" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto" ref={sectionRef}>
        {/* Header */}
        <div data-component-id="src/app/homepage/components/ServicesSection.tsx:106:8" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="106" data-component-end-line="131" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20md%3Aflex-row%20md%3Aitems-end%20justify-between%20gap-6%20mb-16%22%7D" className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div data-component-id="src/app/homepage/components/ServicesSection.tsx:107:10" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="107" data-component-end-line="126" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
            <div data-component-id="src/app/homepage/components/ServicesSection.tsx:108:12" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="108" data-component-end-line="116" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20mb-4%22%7D" className="flex items-center gap-3 mb-4">
              <div data-component-id="src/app/homepage/components/ServicesSection.tsx:109:14" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="109" data-component-end-line="109" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-px%20w-10%22%7D" className="h-px w-10" style={{ background: 'var(--gold)' }} />
              <span data-component-id="src/app/homepage/components/ServicesSection.tsx:110:14" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="110" data-component-end-line="115" data-component-file="ServicesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-%5B12px%5D%20font-semibold%20tracking-widest%20uppercase%22%2C%22textContent%22%3A%22Our%20Services%22%7D"
                className="text-[12px] font-semibold tracking-widest uppercase"
                style={{ color: 'var(--gold)' }}
              >
                Our Services
              </span>
            </div>
            <h2 data-component-id="src/app/homepage/components/ServicesSection.tsx:117:12" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="117" data-component-end-line="125" data-component-file="ServicesSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-serif%20leading-tight%22%2C%22textContent%22%3A%22Every%20Service%2C%22%7D"
              className="font-serif leading-tight"
              style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)', color: 'var(--espresso)' }}
            >
              Every Service,{' '}
              <span data-component-id="src/app/homepage/components/ServicesSection.tsx:122:14" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="122" data-component-end-line="124" data-component-file="ServicesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22italic%20font-light%22%2C%22textContent%22%3A%22Perfected%22%7D" className="italic font-light" style={{ color: 'var(--rose)' }}>
                Perfected
              </span>
            </h2>
          </div>
          <p data-component-id="src/app/homepage/components/ServicesSection.tsx:127:10" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="127" data-component-end-line="130" data-component-file="ServicesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted%20text-%5B16px%5D%20font-light%20leading-relaxed%20max-w-sm%22%2C%22textContent%22%3A%22From%20a%20quick%20trim%20to%20a%20full%20transformation%20%E2%80%94%20our%20specialists%20bring%20expertise%20and%20care%20to%5Cn%20%20%20%20%20%20%20%20%20%20%20%20every%20appointment.%22%7D" className="text-muted text-[16px] font-light leading-relaxed max-w-sm">
            From a quick trim to a full transformation — our specialists bring expertise and care to
            every appointment.
          </p>
        </div>

        {/* Bento Grid */}
        <div data-component-id="src/app/homepage/components/ServicesSection.tsx:134:8" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="134" data-component-end-line="220" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-5%20auto-rows-auto%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 auto-rows-auto">
          {services.map((service, i) => {
            const isLarge = service.size === 'large';
            const isMedium = service.size === 'medium';

            return (
              <div data-component-id="src/app/homepage/components/ServicesSection.tsx:140:14" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="140" data-component-end-line="217" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                key={service.title}
                className={`service-card service-reveal rounded-3xl p-7 cursor-pointer group relative overflow-hidden ${
                  isLarge ? 'lg:col-span-2 lg:row-span-2' : isMedium ? 'lg:col-span-2' : ''
                }`}
                style={{
                  opacity: 0,
                  transform: 'translateY(30px)',
                  transition:
                    'opacity 0.6s cubic-bezier(0.22,1,0.36,1), transform 0.6s cubic-bezier(0.22,1,0.36,1)',
                  background: isLarge
                    ? 'linear-gradient(145deg, #2C2017 0%, #5C4033 100%)'
                    : 'var(--cream-dark)',
                  border: '1px solid rgba(201,149,108,0.15)',
                }}
              >
                {/* Decorative background circle */}
                <div data-component-id="src/app/homepage/components/ServicesSection.tsx:157:16" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="157" data-component-end-line="160" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20-bottom-12%20-right-12%20w-40%20h-40%20rounded-full%20opacity-10%20group-hover%3Aopacity-20%20transition-opacity%20duration-500%22%7D"
                  className="absolute -bottom-12 -right-12 w-40 h-40 rounded-full opacity-10 group-hover:opacity-20 transition-opacity duration-500"
                  style={{ background: isLarge ? 'var(--gold)' : 'var(--rose)' }}
                />

                {/* Tag */}
                {service.tag && (
                  <span data-component-id="src/app/homepage/components/ServicesSection.tsx:164:18" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="164" data-component-end-line="168" data-component-file="ServicesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                    className={`inline-block text-[10px] font-bold tracking-widest uppercase px-3 py-1 rounded-full mb-4 ${service.tagColor}`}
                  >
                    {service.tag}
                  </span>
                )}

                {/* Icon */}
                <div data-component-id="src/app/homepage/components/ServicesSection.tsx:172:16" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="172" data-component-end-line="182" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300 ${
                    isLarge ? 'bg-gold/20' : 'bg-gold/10'
                  }`}
                >
                  <Icon data-component-id="src/app/homepage/components/ServicesSection.tsx:177:18" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="177" data-component-end-line="181" data-component-file="ServicesSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                    name={service.icon as any}
                    size={22}
                    className={isLarge ? 'text-gold-light' : 'text-gold-deep'}
                  />
                </div>

                {/* Content */}
                <h3 data-component-id="src/app/homepage/components/ServicesSection.tsx:185:16" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="185" data-component-end-line="189" data-component-file="ServicesSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%7D"
                  className={`font-serif mb-3 leading-snug ${isLarge ? 'text-white text-2xl' : 'text-espresso text-xl'}`}
                >
                  {service.title}
                </h3>
                <p data-component-id="src/app/homepage/components/ServicesSection.tsx:190:16" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="190" data-component-end-line="195" data-component-file="ServicesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D"
                  className={`text-[14px] font-light leading-relaxed mb-5 ${isLarge ? 'text-white/65' : 'text-muted'}`}
                  style={{ maxWidth: isLarge ? '320px' : undefined }}
                >
                  {service.desc}
                </p>

                {/* Price + CTA */}
                <div data-component-id="src/app/homepage/components/ServicesSection.tsx:198:16" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="198" data-component-end-line="216" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mt-auto%22%7D" className="flex items-center justify-between mt-auto">
                  <span data-component-id="src/app/homepage/components/ServicesSection.tsx:199:18" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="199" data-component-end-line="203" data-component-file="ServicesSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                    className={`text-[13px] font-semibold ${isLarge ? 'text-gold-light' : 'text-gold-deep'}`}
                  >
                    {service.price}
                  </span>
                  <button data-component-id="src/app/homepage/components/ServicesSection.tsx:204:18" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="204" data-component-end-line="215" data-component-file="ServicesSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                    className={`w-9 h-9 rounded-full flex items-center justify-center group-hover:scale-110 transition-all duration-300 ${
                      isLarge ? 'bg-gold/20 hover:bg-gold' : 'bg-espresso/8 hover:bg-gold'
                    }`}
                    aria-label={`Learn more about ${service.title}`}
                  >
                    <Icon data-component-id="src/app/homepage/components/ServicesSection.tsx:210:20" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="210" data-component-end-line="214" data-component-file="ServicesSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%7D"
                      name="ArrowRightIcon"
                      size={14}
                      className={isLarge ? 'text-gold-light' : 'text-espresso-mid'}
                    />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div data-component-id="src/app/homepage/components/ServicesSection.tsx:223:8" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="223" data-component-end-line="238" data-component-file="ServicesSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mt-14%22%7D" className="text-center mt-14">
          <p data-component-id="src/app/homepage/components/ServicesSection.tsx:224:10" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="224" data-component-end-line="226" data-component-file="ServicesSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted%20text-%5B15px%5D%20mb-5%22%2C%22textContent%22%3A%22Not%20sure%20what%20you%20need%3F%20Our%20specialists%20will%20guide%20you.%22%7D" className="text-muted text-[15px] mb-5">
            Not sure what you need? Our specialists will guide you.
          </p>
          <button data-component-id="src/app/homepage/components/ServicesSection.tsx:227:10" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="227" data-component-end-line="237" data-component-file="ServicesSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20px-8%20py-3.5%20rounded-full%20text-%5B14px%5D%20font-semibold%20text-white%20hover%3Ashadow-gold-lg%20hover%3Ascale-105%20transition-all%20duration-300%22%2C%22textContent%22%3A%22Book%20a%20Consultation%22%7D"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-[14px] font-semibold text-white hover:shadow-gold-lg hover:scale-105 transition-all duration-300"
            style={{ background: 'linear-gradient(135deg, #A8724A 0%, #C9956C 100%)' }}
          >
            Book a Consultation
            <Icon data-component-id="src/app/homepage/components/ServicesSection.tsx:236:12" data-component-path="src/app/homepage/components/ServicesSection.tsx" data-component-line="236" data-component-end-line="236" data-component-file="ServicesSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%2C%22className%22%3A%22text-white%22%7D" name="ArrowRightIcon" size={14} className="text-white" />
          </button>
        </div>
      </div>
    </section>
  );
}
